export default __webpack_public_path__ + "static/media/right-arrow.c24ea129.svg";